/**
 * Created by Ivan on 19.05.2024
 */

const StickersCompletedWindow = CleverappsWindow.extend({
    ctor: function (index, ...args) {
        this.collectionIndex = index;

        this._super(index, ...args);
    },

    onWindowLoaded: function () {
        const content = this.createContent();

        this._super({
            content,
            name: "StickersCompletedWindow",
            noBackground: true,
            title: Messages.get("StickersCompletedWindow.Title"),
            closeButtonDelay: 1
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.StickersCompletedWindow;

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize(styles.width, styles.height);

        this.stickers = [];

        this.createCollection();

        const rewardList = this.rewardList = new RewardsListComponent(StickersBook.getCollectionReward(this.collectionIndex), {
            font: cleverapps.styles.FONTS.WHITE_TEXT,
            margin: styles.rewardList.margin,
            event: cleverapps.EVENTS.EARN.STICKERS_BOOK,
            toMainWorld: !cleverapps.meta.getSelectedLocation().locationConfig.isMain
        });
        rewardList.setVisible(false);
        rewardList.setCascadeOpacityEnabledRecursively(true);
        rewardList.setOpacity(0);
        content.addChild(rewardList);
        rewardList.setAlignment(styles.layout);

        return content;
    },

    createCollection: function () {
        const styles = cleverapps.styles.StickersCompletedWindow;

        this.stickers = cleverapps.stickersBook.collections[this.collectionIndex].stickers.map((sticker) => {
            const ViewClass = sticker.getViewClass();
            const stickerView = new ViewClass(sticker);
            return stickerView;
        });

        for (let index = 0; index < this.stickers.length; index++) {
            this.content.addChild(this.stickers[index], this.stickers.length - index);
            this.stickers[index].setAlignment(styles.stickers);
        }

        this.setupStickersPositions();
    },

    stickersCompleteAnimation: function (isReverse, animationDelay) {
        const styles = cleverapps.styles.StickersCompletedWindow;
        animationDelay = animationDelay || 0;

        for (let index = 1; index < this.stickers.length; index++) {
            const stickerView = this.stickers[index];
            let position, rotation, delay;
            const pairIndex = Math.floor((index + 1) / 2);

            if (isReverse) {
                position = stickerView.getPosition();
                rotation = stickerView.getRotation();
                delay = pairIndex * 0.08;
                stickerView.setPosition(stickerView.positionFromAlignment(styles.stickers));
                stickerView.setRotation(0);
            } else {
                position = stickerView.positionFromAlignment(styles.stickers);
                rotation = -stickerView.getRotation();
                delay = (Math.floor(this.stickers.length / 2) - pairIndex) * 0.08;
            }

            stickerView.runAction(new cc.Sequence(
                new cc.DelayTime(animationDelay + delay),
                new cc.Spawn(
                    new cc.MoveTo(0.35, position.x, position.y).easing(isReverse ? cc.easeBackOut() : cc.easeBackIn()),
                    new cc.RotateBy(0.35, rotation)
                )
            ));
        }
    },

    onShow: function () {
        this._super();

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.CallFunc(() => {
                cleverapps.effects.fire("stickers.window.open");
            })
        ));

        this.stickersCompleteAnimation(true, 0.5);

        const rewardOffsetY = cleverapps.styles.StickersCompletedWindow.rewardOffsetY;
        this.rewardList.runAction(new cc.Sequence(
            new cc.DelayTime(1.25),
            new cc.MoveBy(0, 0, rewardOffsetY),
            new cc.Show(),
            new cc.Spawn(
                new cc.FadeIn(0.2),
                new cc.MoveBy(0.2, 0, -rewardOffsetY).easing(cc.easeBackOut())
            )
        ));
    },

    setupStickersPositions: function () {
        const styles = cleverapps.styles.StickersCompletedWindow;

        let offsetY = 0;
        for (let index = 0; index < this.stickers.length; index++) {
            const stickerView = this.stickers[index];
            stickerView.setAlignment(styles.stickers);

            const isEvenIndex = index && index % 2 === 0;
            const pairIndex = Math.floor((index + 1) / 2);
            const offsetX = pairIndex * styles.offset.x * (isEvenIndex ? -1 : 1);
            const rotateAngle = pairIndex * 3 * (isEvenIndex ? -1 : 1);

            stickerView.setAlignment(cc.p(stickerView.getPosition().x + offsetX, stickerView.getPosition().y + offsetY));
            stickerView.setRotation(rotateAngle);

            offsetY -= styles.offset.y * index * isEvenIndex;
        }
    },

    beforeCloseAnimation: function (callback) {
        this.rewardList.receiveRewards();
        this.rewardList.receiveRewardsAnimation({
            callback
        });

        this.stickersCompleteAnimation();

        this.runAction(new cc.Sequence(
            new cc.CallFunc(() => {
                cleverapps.effects.fire("stickers.window.close");
            }),
            new cc.DelayTime(0.95),
            new cc.CallFunc(() => {
                this.windowTitle.hide();
            }),
            new cc.DelayTime(0.3),
            new cc.CallFunc(() => {
                const windowComponent = ComponentMap.get(this, WindowComponent);
                windowComponent.hideWindow();
            })
        ));
    },

    listBundles: function () {
        const collectionBundle = cleverapps.stickersBook.collectionBundle(this.collectionIndex);
        return ["stickers_completed_window"].concat([collectionBundle]);
    }
});

cleverapps.styles.StickersCompletedWindow = {
    width: 650,
    height: 900,

    layout: {
        x: { align: "center" },
        y: { align: "center", dy: -200 },
        margin: 50
    },

    rewardOffsetY: 100,

    rewardList: {
        margin: 30
    },

    stickers: {
        x: { align: "center" },
        y: { align: "center", dy: 170 }
    },

    offset: {
        x: 80,
        y: 4
    }
};
